import { ClaraEvent } from '@/modules/ai/events/ClaraEvent';
import { ContentLibraryEvent } from '@/modules/ai/events/ContentLibraryEvent';

export const NavToggleMixin = {
  events() {
    return {
      [ClaraEvent.ON_SHOW_CLARA_INTRO]: () => this.toggleNav(false),
      [ClaraEvent.CLARA_INPUT_FOCUSED]: () => this.toggleNav(true),
      [ContentLibraryEvent.CONTENT_SOURCE_CLICKED]: () => this.toggleNav(false),
      [ContentLibraryEvent.DASHBOARD_VIEWED]: () => this.toggleNav(true)
    };
  },
  data() {
    return {
      isNavVisible: true
    };
  },
  computed: {
    style() {
      return {
        'margin-left': this.isNavVisible && !this.isViewingEstateDetails ? '' : '0'
      };
    }
  },
  methods: {
    toggleNav(isNavVisible) {
      this.isNavVisible = isNavVisible;
    }
  }
};
